import { useEffect } from 'react';
import { useInstanceId } from './useInstanceId';
import { bridge, isApp } from '../utils';

export const useReportTTFD = () => {
  const instanceId = useInstanceId();

  useEffect(() => {
    if (!instanceId) {
      return;
    }
    if (isApp()) {
      bridge.reportTTFD({ instanceId });
    }
  }, [instanceId]);
};
